import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import storage from "../api/storage"
import Login from '@/page/Login'
import Main from '@/page/Main'
import Index from '@/page/Index'
import ShowSet from '@/page/ShowSet'
import ShowData from '@/page/ShowData'
import Logistics from '@/page/Logistics'
import SellerMemo from '@/page/SellerMemo'
import Item from '@/page/Item'
import Sku from '@/page/Sku'
import Custom from '@/page/Custom'
// import Split from '@/page/Split'
// import TanShan from '@/page/TanShan'

import Help from '@/page/Help'

import KddTemp from '@/print/KddTemp'
import Design from '@/print/Design'
import Print from '@/print/Print'
import Free from '@/print/Free'

import AdmLogin from '@/admin/AdmLogin'
import AdmMain from '@/admin/AdmMain'
import AdmAccess from '@/admin/AdmAccess'
import AdmSmsLog from '@/admin/AdmSmsLog'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/AdmLogin',
      name: 'AdmLogin',
      component: AdmLogin,
    },

    {
      path: '/AdmMain',
      name: 'AdmMain',
      component: AdmMain,
      children:[
        {
          path: '/AdmAccess',
          name: 'AdmAccess',
          component: AdmAccess,
        },
        {
          path: '/AdmSmsLog',
          name: 'AdmSmsLog',
          component: AdmSmsLog,
        },
      ]
    },
    {
      path: '/Main',
      name: '/Main',
      component: Main,
      children:[
        {
          path: '/Index',
          name: 'Index',
          component: Index,
        },
        {
          path: '/ShowSet',
          name: 'ShowSet',
          component: ShowSet,
        },
        {
          path: '/ShowData',
          name: 'ShowData',
          component: ShowData,
        },
        {
          path: '/Logistics',
          name: 'Logistics',
          component: Logistics,
        },
        {
          path: '/SellerMemo',
          name: 'SellerMemo',
          component: SellerMemo,
        },

        {
          path: '/Item',
          name: 'Item',
          component: Item,
        },
        {
          path: '/Sku',
          name: 'Sku',
          component: Sku,
        },
        {
          path: '/Custom',
          name: 'Custom',
          component: Custom,
        },
        /*{
          path: '/Split',
          name: 'Split',
          component: Split,
        },
        {
          path: '/TanShan',
          name: 'TanShan',
          component: TanShan,
        },*/
        {
          path: '/Help',
          name: 'Help',
          component: Help,
        },
        {
          path: '/KddTemp',
          name: 'KddTemp',
          component: KddTemp,

        },
        {
          path: '/Design',
          name: 'Design',
          component: Design,
        },
        {
          path: '/Print',
          name: 'Print',
          component: Print,
        },
        {
          path: '/Free',
          name: 'Free',
          component: Free,
        },
      ]
    }
  ]
})

router.beforeEach(function (to, form, next) {
  const token = storage.get("token");
  const user = storage.get("nick");

  //const venderId =  storage.get("venderId");


  /*try  {
    let  venderId =  storage.get("venderId");
  }  catch(err)
  {
    //在此处理错误
  }*/

  if (to.name === "AdmMain") {
    router.replace({name: 'AdmAccess'});

  }

  if (to.name === "Main") {
    router.replace({name: 'Index'});
    storage.set("active", "1")
  }


 /* if(to.name === "Custom") {
    // 10269241
    if (venderId == "10269241") {
      router.replace({name: 'Split'});
    }
    else if ((venderId =="10327980") ||(venderId == "674754")) {
      router.replace({name: 'Split'});
    }
    else if (venderId == "91414") {   //91414 泰山啤酒旗舰店
      router.replace({name: 'TanShan'});
    }
  }*/

  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js